import {
    CREATE_YARN_INWARD_DETAILS_FAILURE_DK,
    CREATE_YARN_INWARD_DETAILS_REQUEST_DK,
    CREATE_YARN_INWARD_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_YARN_INWARD_DETAILS_DK,
    DELETE_YARN_INWARD_DETAILS_FAILURE_DK,
    DELETE_YARN_INWARD_DETAILS_REQUEST_DK,
    DELETE_YARN_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_YARN_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_YARN_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_YARN_INWARD_DETAILS_SUCCESS_DK,
    FETCH_YARN_INWARD_DETAILS_FAILURE_DK,
    FETCH_YARN_INWARD_DETAILS_REQUEST_DK,
    FETCH_YARN_INWARD_DETAILS_SUCCESS_DK,
    YARN_INWARD_DETAILS_USERFORM_RESET_DK,
    UPDATE_YARN_INWARD_DETAILS_FAILURE_DK,
    UPDATE_YARN_INWARD_DETAILS_REQUEST_DK,
    UPDATE_YARN_INWARD_DETAILS_SUCCESS_DK,
    FETCH_YARN_INWARD_DETAILS_BY_ID_REQUEST_DK,
    FETCH_YARN_INWARD_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_PREVIOUS_YARN_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_YARN_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_YARN_INWARD_DETAILS_FAILURE_DK,
    YARN_INWARD_DETAILS_PO_DETAILS_DISABLED_DK
} from './yarnInwardDetails.actionsType';

export const YARN_INWARD_DK_DETAILS = 'yarnInwardDetailsDK';

let initialState = {
    loading: false,
    yarnInwardDetailsById: [],
    yarnInwardDetails: [],
    previousGetList: [],
    isPoDetailsDisabled: false,
    yarnInwardDetailsForm: {
        fldRatePerKG: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldNoofBags: 0,
        fldBagWeight: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedYarnInwardDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let yarnInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_YARN_INWARD_DETAILS_REQUEST_DK:
        case FETCH_YARN_INWARD_DETAILS_BY_ID_REQUEST_DK:
        case FETCH_PREVIOUS_YARN_INWARD_DETAILS_REQUEST_DK:
        case CREATE_YARN_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_YARN_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_YARN_INWARD_DETAILS_REQUEST_DK:
        case DELETE_YARN_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_YARN_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnInwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_YARN_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case FETCH_YARN_INWARD_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnInwardDetailsById: updatePayload
            };

        case CREATE_YARN_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnInwardDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldNoofBags: 0,
                    fldBagWeight: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isPoDetailsDisabled: false
            };

        case FETCH_SINGLE_YARN_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedYarnInwardDetails: updatePayload,
                yarnInwardDetailsForm: updatePayload
            };
        case UPDATE_YARN_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedYarnInwardDetails: {},
                yarnInwardDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldNoofBags: 0,
                    fldBagWeight: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isPoDetailsDisabled: false
            };
        case DELETE_YARN_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                yarnInwardDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldNoofBags: 0,
                    fldBagWeight: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isPoDetailsDisabled: false,
                selectedYarnInwardDetails: {}
            };

        case FETCH_YARN_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_YARN_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_YARN_INWARD_DETAILS_FAILURE_DK:
        case CREATE_YARN_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_YARN_INWARD_DETAILS_FAILURE_DK:
        case DELETE_YARN_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_YARN_INWARD_DETAILS_DK:
            return {
                ...state,
                loading: false,
                yarnInwardDetailsForm: {
                    ...state.yarnInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case YARN_INWARD_DETAILS_PO_DETAILS_DISABLED_DK:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case YARN_INWARD_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                yarnInwardDetailsForm: {
                    fldRatePerKG: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldNoofBags: 0,
                    fldBagWeight: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                },
                isPoDetailsDisabled: false,
                selectedYarnInwardDetails: {}
            };
        default:
            return state;
    }
};
